import {
    ENUM_FIELD_OPERATORS,
    FIELD_TYPE,
    MULTI_OPTIONS_OPERATORS,
    NUMBER_FIELD_OPERATORS,
    STRING_FIELD_OPERATORS,
} from './campaigns-filter.types';
import { NEW_FILTER } from './filters/filters.constants';
import { FIELD } from './rules/rules.types';

export const CAMPAIGNS_FILTER_TEST_IDS = {
    DRAWER: 'drawer',
    ICON_BUTTON: 'icon-button',
    TAG: 'campaigns-filter-tag',
    SAVE_MODAL: 'campaigns-filter-save-modal',
};

export const CAMPAIGNS_FILTER_AUTO_TEST_IDS = {
    DRAWER: 'drawer',
    ICON_BUTTON: 'icon-button',
    TAG: 'campaigns-filter-tag',
    TAG_CLOSE: 'campaigns-filter-close-tag',
    SAVE_MODAL: 'campaigns-filter-save-modal',
};

export const AVAILABLE_FIELDS = [{
    name: FIELD.STATUS,
    type: FIELD_TYPE.ENUM,
    operations: ENUM_FIELD_OPERATORS,
    unique: false,
}, {
    name: FIELD.CAMPAIGNS,
    type: FIELD_TYPE.MULTI_OPTIONS,
    operations: MULTI_OPTIONS_OPERATORS,
    unique: true,
}];

export const OPERATORS_BY_FIELD_TYPE = {
    [FIELD_TYPE.ENUM]: ENUM_FIELD_OPERATORS,
    [FIELD_TYPE.NUMBER]: NUMBER_FIELD_OPERATORS,
    [FIELD_TYPE.STRING]: STRING_FIELD_OPERATORS,
    [FIELD_TYPE.MULTI_OPTIONS]: MULTI_OPTIONS_OPERATORS,
};

export const DEFAULT_FILTER = { activeFilter: NEW_FILTER, customFilters: [] };

export const DEFAULT_CAMPAIGNS_FILTERS_CONFIG = {
    client: {},
    account: {},
};

export const CAMPAIGNS_FILTER_TEXTS = {
    TOOLTIP: {
        DISABLED: 'Enabled only for Campaign segment',
    },
};
